import { ETaskStatus } from '@constants';
import { useCallback, useEffect } from 'react';

import { ActivityPreview } from '../ActivityPreview';

import { ChangeStatusForm } from './ChangeStatusForm';
import { TaskList } from './TaskList';
import { TaskLogsModal } from './TaskLogsModal';
import { Wrapper } from './TasksPanel.styles';

import { useCourseTasks } from '@/store';

type Props = {
  courseId?: string;
  teacherId?: string;
};

const SCROLL_THRESHOLD = 100;

export const TasksPanel: React.FC<Props> = ({ courseId, teacherId }) => {
  const {
    pendingAndRejectedTasks = [],
    reviewTasks = [],
    approvedTasks = [],
    setSelectedCourse,
    setSelectedTeacher
  } = useCourseTasks();

  useEffect(() => {
    setSelectedCourse(courseId);
  }, [courseId]);

  useEffect(() => {
    if (teacherId) {
      setSelectedTeacher(teacherId);
    }
  }, [teacherId]);

  const onScroll = useCallback(
    (
      ref: React.RefObject<HTMLDivElement | null>,
      isFetchingNextPage: boolean,
      fetchNextPage: () => void
    ) => {
      if (ref.current && !isFetchingNextPage) {
        const { scrollTop, scrollHeight, clientHeight } = ref.current;
        const scrollPosition = scrollHeight - scrollTop - clientHeight;

        if (scrollPosition < SCROLL_THRESHOLD) fetchNextPage();
      }
    },
    []
  );

  return (
    <>
      <Wrapper>
        <TaskList
          tasks={pendingAndRejectedTasks}
          status={ETaskStatus.PENDING}
          onScroll={onScroll}
        />
        <TaskList tasks={reviewTasks} status={ETaskStatus.IN_REVIEW} onScroll={onScroll} />
        <TaskList tasks={approvedTasks} status={ETaskStatus.APPROVED} onScroll={onScroll} />
      </Wrapper>
      <TaskLogsModal />
      <ChangeStatusForm />
      <ActivityPreview />
    </>
  );
};
